<!--
 * @LastEditors: 八千
 -->
<template>
  <div>
    <div id="newHeader" class="mobile" style="height:55px"></div>
    <!-- PC端头部 -->
    <div class="container1920sub relative newheader">
      <div class="row">
        <div class="one half mobile">
          <a href="https://www.csvw.com/csvw-website/module/index.html">
            <img
              class="fn-left logo-csvw"
              src="data:image/png;base64,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"
            />
<!--            <img class="fn-left logo-csvw" src="../assets/images/index/logo-2023@2x.png">-->
          </a>
        </div>
        <div class="one half mobile">
          <!-- <img class="fn-right hamburger hide-on-ipad  hide-on-desktop hide-on-ipad" src="data:image/gif;base64,R0lGODlhKgAhAIABAGFhYf///yH5BAEAAAEALAAAAAAqACEAAAJXhB95y+3fUoC0Qmmzxrpf5YUMJ2bSiabqyrbuC8cyG4GlSN5erm9275sAO7zhYoZMKpdMWU1otBSjjil19LtWs1ostNsMi8fk1LP7+aKP3DXAioaD29ECADs="
          alt="">-->
          <button class="fn-right hamburger hide-on-ipad hide-on-desktop hide-on-ipad btn-nav">
            <span class="icon-bar top"></span>
            <span class="icon-bar middle"></span>
            <span class="icon-bar bottom"></span>
          </button>

          <!--MOB 搜索按钮-->
          <div class="searchIcon fn-right hide-on-ipad hide-on-desktop" @click="isMobSearch=!isMobSearch"></div>
          <!--MOB 搜索框-->
          <div class="mobSearch hide-on-ipad hide-on-desktop" v-show="isMobSearch">
            <div class="icon" @click="handleSearchMob"></div>
            <input type="text" placeholder="新车 纯电 智能 销量 权益" v-model="searchVal"
                   onfocus="this.placeholder=''" onblur="this.placeholder='新车 纯电 智能 销量 权益'" />
          </div>
          <!--PC 搜索框-->
<!--          <div class="fn-right hide-on-ipad hide-on-small-tablet hide-on-mobile">-->
<!--            <div class="search ">-->
<!--              <div class="icon-sou"></div>-->
<!--              <input type="text" placeholder="新车 纯电 智能 销量 权益" onfocus="this.placeholder=''"-->
<!--                     onblur="this.placeholder='新车 纯电 智能 销量 权益'" class="icon-search">-->
<!--            </div>-->
<!--          </div>-->
          <!--PC 搜索框-->

          <div class="fn-right hide-on-ipad hide-on-small-tablet hide-on-mobile">
            <div class="search">
              <div class="icon-sou"></div>
              <input
                type="text"
                placeholder="新车 纯电 智能 销量 权益"
                onfocus="this.placeholder=''"
                onblur="this.placeholder='新车 纯电 智能 销量 权益'"
                class="icon-search"
                v-model="searchValue"
                @keyup.enter="handleSearch"
                style="height: 22.5px"
              />
            </div>
          </div>

        </div>
      </div>

      <nav
        class="nav lv2-nav-flag hide-on-ipad hide-on-small-tablet hide-on-mobile hide"
        title
        style="display: block;"
      >
        <ul class="oneul">
          <li class="lilv1 lilv1index">
            <button onclick="window.location='https://www.csvw.com/csvw-website/module/index.html'">
              <span>首页</span>
            </button>
          </li>
          <li class="lilv1">
            <button onclick="window.location='https://www.csvw.com/csvw-website/module/about.html'">
              <span>关于企业</span>
            </button>
            <ul class="lilv1-next subnavul01">
              <li>
                <a href="https://www.csvw.com/csvw-website/module/about.html">企业概述</a>
              </li>
              <li>
                <a href="https://www.csvw.com/csvw-website/about/intro.html">企业文化与战略</a>
              </li>
              <li>
                <a href="https://www.csvw.com/csvw-website/about/history.html">发展历程</a>
              </li>
              <li>
                <a href="https://www.csvw.com/special3/#/factory">工厂布局</a>
              </li>
              <li>
                <a href="https://www.csvw.com/csvw/thirdpart/responsibility/">社会责任</a>
              </li>
              <li class="hide-on-ipad hide-on-small-tablet hide-on-mobile">
                <a href="https://www.csvw.com/csvw-website/about/report.html">企业年刊</a>
              </li>
              <li>
                <a href="https://www.csvw.com/csvw-website/about/honor.html">企业荣誉</a>
              </li>
            </ul>
          </li>
          <li class="lilv1">
            <button
              onclick="window.location='https://www.csvw.com/csvw-website/news/company-news.html'"
            >
<!--              <span class="active">新闻中心</span>-->
              <span>新闻中心</span>
            </button>
            <ul class="lilv1-next subnavul02">
              <li>
                <a href="https://www.csvw.com/csvw-website/news/company-news.html">企业新闻</a>
              </li>
              <li>
                <a href="https://www.csvw.com/csvw-website/news/activities.html">专题报道</a>
              </li>
              <li>
                <a href="https://www.csvw.com/csvw-website/news/company-bulletin.html">企业公告</a>
              </li>
              <li>
                <a href="https://www.csvw.com/csvw-website/news/dz-brand-news.html?brand=vw&title=大众品牌新闻_上汽大众官网">大众品牌新闻</a>
              </li>
              <li>
                <a href="https://www.csvw.com/csvw-website/news/audi-brand-news.html?brand=audi&title=奥迪品牌新闻_上汽大众官网">奥迪品牌新闻</a>
              </li>
              <li>
                <a href="https://www.csvw.com/csvw-website/news/skoda-brand-news.html?brand=skoda&title=斯柯达品牌新闻_上汽大众官网">斯柯达品牌新闻</a>
              </li>
            </ul>
          </li>
          <li class="lilv1">
            <button onclick="window.location='https://www.csvw.com/csvw-website/brand/vw.html'">
              <span>品牌与车型</span>
            </button>
            <ul class="lilv1-next subnavul03" style="width: 430px;">
              <li>
                <a href="https://www.csvw.com/csvw-website/brand/vw.html">大众品牌车型</a>
              </li>
              <li>
                <a href="https://www.csvw.com/csvw-website/brand/audi.html">奥迪品牌车型</a>
              </li>
              <li>
                <a href="https://www.csvw.com/csvw-website/brand/skoda.html">斯柯达品牌车型</a>
              </li>
            </ul>
          </li>
          <li class="lilv1">
            <button onclick="window.open('/svwmedia-website/index/index.html', '_blank')">
              <span>下载中心</span>
            </button>
            <ul class="lilv1-next subnavul03" style="width: 430px;">
              <li>
                <a href="https://www.csvw.com/svwmedia-website/index/index.html#vehicle" target="_blank">车型资料</a>
              </li>
              <li>
                <a href="https://www.csvw.com/svwmedia-website/index/index.html#anchor" target="_blank">企业资料</a>
              </li>
            </ul>
          </li>
          <li class="lilv1">
            <button onclick="window.location='https://www.csvw.com/technology/classroom'">
              <span>汽车课堂</span>
            </button>
            <ul class="lilv1-next subnavul03" style="width: 430px;">
              <li>
                <a href="https://www.csvw.com/technology/classroom#class1">入门指南</a>
              </li>
              <li>
                <a href="https://www.csvw.com/technology/classroom#class2">品质讲堂</a>
              </li>
              <li>
                <a href="https://www.csvw.com/technology/classroom#class3">汽车档案</a>
              </li>
            </ul>
          </li>
          <li class="lilv1">
            <button
              onclick="window.location='/special3/#/join-us'"
            >
              <span>加入我们</span>
            </button>
            <ul class="lilv1-next subnavul05" style="width:349px">
              <li>
                <a href="/special3/#/join-us?type=Recruitment">企业招聘</a>
              </li>
              <li>
                <a href="/special3/#/join-us?type=dealerRecruitment">经销商招募</a>
              </li>
              <li>
                <a href="/special3/#/join-us?type=agentRecruitment">代理商招募</a>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
      <div class="blackmask"></div>
    </div>
    <!-- 移动端头部 -->
    <div class="full_width border1b_e1e1e1 absolute niubnav hide-on-desktop hide-on-ipad" style="z-index: 999999">
      <ul>
        <li class="lil1">
          <a href="https://www.csvw.com/csvw-website/module/index.html">首页</a>
        </li>
        <li class="lil1 lil1hassub rolemenu">
          <a href="javascript:;">关于企业</a>
          <ul class="subnav subnav1">
            <li>
              <a href="https://www.csvw.com/csvw-website/module/about.html">企业概述</a>
            </li>
            <li>
              <a href="https://www.csvw.com/csvw-website/about/intro.html">企业文化与战略</a>
            </li>
            <li>
              <a href="https://www.csvw.com/csvw-website/about/history.html">发展历程</a>
            </li>
            <li>
              <a href="https://www.csvw.com/special3/#/factory">工厂布局</a>
            </li>
            <li>
              <a href="https://www.csvw.com/csvw/thirdpart/responsibility/">社会责任</a>
            </li>
            <li class="hide-on-ipad hide-on-small-tablet hide-on-mobile">
              <a href="https://www.csvw.com/csvw-website/about/report.html">企业年刊</a>
            </li>
            <li>
              <a href="https://www.csvw.com/csvw-website/about/honor.html">企业荣誉</a>
            </li>
          </ul>
        </li>
        <li class="lil1 lil1hassub rolemenu">
          <a href="javascript:;">新闻中心</a>
          <ul class="subnav subnav2">
            <li>
              <a href="https://www.csvw.com/csvw-website/news/company-news.html">企业新闻</a>
            </li>
            <li>
              <a href="https://www.csvw.com/csvw-website/news/activities.html">专题报道</a>
            </li>
            <li>
              <a href="https://www.csvw.com/csvw-website/news/company-bulletin.html">企业公告</a>
            </li>
            <li>
              <a href="https://www.csvw.com/csvw-website/news/dz-brand-news.html?brand=vw&title=大众品牌新闻_上汽大众官网">大众品牌新闻</a>
            </li>
            <li>
              <a href="https://www.csvw.com/csvw-website/news/audi-brand-news.html?brand=audi&title=奥迪品牌新闻_上汽大众官网">奥迪品牌新闻</a>
            </li>
            <li>
              <a href="https://www.csvw.com/csvw-website/news/skoda-brand-news.html?brand=skoda&title=斯柯达品牌新闻_上汽大众官网">斯柯达品牌新闻</a>
            </li>
            <!-- class="hide-on-ipad hide-on-small-tablet hide-on-mobile" -->
            <!--                    <li>-->
            <!--                        <a href="/svwmedia-website/index/" target="_blank">媒体中心</a>-->
            <!--                    </li>-->
          </ul>
        </li>
        <li class="lil1 lil1hassub rolemenu">
          <a href="javascript:;">品牌与车型</a>
          <ul class="subnav subnav3">
            <li>
              <a href="https://www.csvw.com/csvw-website/brand/vw.html?brand=vw&title=大众车型_大众品牌车型_上汽大众官网">大众品牌车型</a>
            </li>
            <li>
              <a href="https://www.csvw.com/csvw-website/brand/audi.html?brand=audi&title=奥迪车型_奥迪品牌车型_上汽大众官网">奥迪品牌车型</a>
            </li>
            <li>
              <a href="https://www.csvw.com/csvw-website/brand/skoda.html?brand=skoda&title=斯柯达车型_斯柯达品牌车型_上汽大众官网">斯柯达品牌车型</a>
            </li>
          </ul>
        </li>
        <li class="lil1 lil1hassub rolemenu">
          <a href="javascript:;">下载中心</a>
          <ul class="subnav subnav5">
            <li>
              <a href="https://www.csvw.com/svwmedia-website/index/index.html#vehicle" target="_blank">车型资料</a>
            </li>
            <li>
              <a href="https://www.csvw.com/svwmedia-website/index/index.html#anchor" target="_blank">企业资料</a>
            </li>
          </ul>
        </li>
        <li class="lil1 lil1hassub rolemenu">
          <a href="javascript:;">汽车课堂</a>
          <ul class="subnav subnav5">
            <li>
              <a href="https://www.csvw.com/technology/classroom#class1">入门指南</a>
            </li>
            <li>
              <a href="https://www.csvw.com/technology/classroom#class2">品质讲堂</a>
            </li>
            <li>
              <a href="https://www.csvw.com/technology/classroom#class3">汽车档案</a>
            </li>
          </ul>
        </li>
        <li class="lil1 lil1hassub rolemenu">
          <a href="javascript:;">加入我们</a>
          <ul class="subnav subnav4">
            <li>
              <a href="/special3/#/join-us?type=Recruitment">企业招聘</a>
            </li>
            <li>
              <a href="/special3/#/join-us?type=dealerRecruitment">经销商招募</a>
            </li>
            <li>
              <a href="/special3/#/join-us?type=agentRecruitment">代理商招募</a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  data() {
    return {
      isMobSearch:false,
      searchVal:'',
      searchValue: ""
    };
  },
  mounted() {
    this.mobileMenu();
    this.pcMenu();
  },
  methods: {
    handleSearchMob(){
      let search = escape(this.searchVal.trim());
      search &&
      window.open(
          `https://www.csvw.com/csvw-website/module/search.html?search=${search}`
      );
    },
    handleSearch() {
      let search = escape(this.searchValue.trim());
      search &&
        window.open(
          `https://www.csvw.com/csvw-website/module/search.html?search=${search}`
        );
    },
    mobileMenu() {
      $(".hamburger").on("click", function() {
        $(this).toggleClass("animated");
        $(".niubnav").toggle();
      });
      $(".lil1hassub > a").on("click", function() {
        $(this)
          .siblings("ul")
          .slideToggle();
      });
    },

    pcMenu() {
      var sf = this;
      $(".nav .oneul .lilv1")
        .not(".lilv1index, .lilv1tk")
        .mouseenter(function() {
          //sf.disableScroll();
          $(".blackmask").show();
          $(this)
            .children()
            .eq(1)
            .show();
        })
        .mouseleave(function() {
          //sf.enableScroll();
          $(".blackmask").hide();
          $(this)
            .children()
            .eq(1)
            .hide();
        });
    },
    disableScroll: function() {
      var sf = this;
      if (window.addEventListener)
        // older FF
        window.addEventListener("DOMMouseScroll", sf.preventDefault, false);
      window.onwheel = sf.preventDefault; // modern standard
      window.onmousewheel = document.onmousewheel = sf.reventDefault; // older browsers, IE
      window.ontouchmove = sf.preventDefault; // mobile
      document.onkeydown = sf.preventDefaultForScrollKeys;
    },

    enableScroll: function() {
      var sf = this;
      if (window.removeEventListener)
        window.removeEventListener("DOMMouseScroll", sf.preventDefault, false);
      window.onmousewheel = document.onmousewheel = null;
      window.onwheel = null;
      window.ontouchmove = null;
      document.onkeydown = null;
    }
  }
};
</script>
<style scoped src="../assets/less/about.css"></style>
<style scoped src="../assets/less/groundwork.css"></style>
<style scoped src="../assets/less/main.css"></style>
<style scoped src="../assets/less/swiper.min.css"></style>
